import { Point, Rectangle } from 'pixi.js';

const corner = new Point();
const relativeCorner = new Point();
const corners = [new Point(), new Point(), new Point(), new Point()];

/**
 * Returns a display object's axis-aligned bounds in an ancestor's coordinate
 * space. Pixi 8 getBounds() is global, while editor physics coordinates are
 * local to the camera container.
 */
export const getBoundsRelativeTo = (displayObject, targetSpace, out = new Rectangle()) => {
	const bounds = displayObject.getLocalBounds();
	const left = bounds.minX;
	const top = bounds.minY;
	const right = bounds.maxX;
	const bottom = bounds.maxY;

	if (![left, top, right, bottom].every(Number.isFinite)) {
		corner.set(0, 0);
		targetSpace.toLocal(corner, displayObject, relativeCorner);
		out.x = relativeCorner.x;
		out.y = relativeCorner.y;
		out.width = 0;
		out.height = 0;
		return out;
	}

	corners[0].set(left, top);
	corners[1].set(right, top);
	corners[2].set(right, bottom);
	corners[3].set(left, bottom);

	let minX = Number.POSITIVE_INFINITY;
	let minY = Number.POSITIVE_INFINITY;
	let maxX = Number.NEGATIVE_INFINITY;
	let maxY = Number.NEGATIVE_INFINITY;

	for (const localCorner of corners) {
		targetSpace.toLocal(localCorner, displayObject, relativeCorner);
		minX = Math.min(minX, relativeCorner.x);
		minY = Math.min(minY, relativeCorner.y);
		maxX = Math.max(maxX, relativeCorner.x);
		maxY = Math.max(maxY, relativeCorner.y);
	}

	out.x = minX;
	out.y = minY;
	out.width = maxX - minX;
	out.height = maxY - minY;
	return out;
};

/**
 * Tests a display object's rendered shape using a point expressed in another
 * display object's coordinate space. Pixi 8 containsPoint() expects local
 * coordinates and no longer applies the display object's transform itself.
 */
export const containsPointRelativeTo = (displayObject, point, sourceSpace) => {
	if (!displayObject || typeof displayObject.containsPoint !== 'function') return false;

	const localPoint = displayObject.toLocal(point, sourceSpace);
	return displayObject.containsPoint(localPoint);
};
